import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { MelioLogo } from '@/components/ds';
import { useGo } from '@/lib/useGo';
import { asset } from '@/lib/assets';

const NAV: { path: string; label: string }[] = [
  { path: '/docs', label: 'API reference' },
  { path: '/simulator', label: 'Simulator' },
];

function Tab({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '8px 12px',
        borderRadius: 8,
        border: 'none',
        background: active ? 'var(--neutral-300)' : hover ? 'var(--neutral-200)' : 'transparent',
        color: active ? 'var(--text-primary)' : 'var(--text-secondary)',
        fontFamily: 'var(--font-linear-sans)',
        fontSize: 14,
        lineHeight: '24px',
        fontWeight: 400,
        cursor: 'pointer',
        transition: 'background-color .15s',
      }}
    >
      {label}
    </button>
  );
}

export function TopNav() {
  const go = useGo();
  const { pathname } = useLocation();
  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'saturate(180%) blur(12px)',
        WebkitBackdropFilter: 'saturate(180%) blur(12px)',
        borderBottom: '1px solid var(--border-static)',
      }}
    >
      <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 24 }}>
        <button
          onClick={() => go('/')}
          style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          <MelioLogo height={24} />
          <span style={{ width: 1, height: 16, background: 'var(--border-static)' }} />
          <img src={asset('api-badge.svg')} alt="API Beta" style={{ height: 14, display: 'block' }} />
        </button>
        <nav style={{ display: 'flex', gap: 8 }}>
          {NAV.map((n) => {
            const active = pathname === n.path || (n.path !== '/' && pathname.startsWith(n.path + '/'));
            return (
              <Tab
                key={n.path}
                label={n.label}
                active={active}
                onClick={() => (n.path === '/docs' ? window.location.assign(n.path) : go(n.path))}
              />
            );
          })}
        </nav>
      </div>
    </header>
  );
}
